"use client";

import { Field as FieldPrimitive } from "@base-ui/react/field";

import { cn } from "@/utils/class-name";

function Field({ className, ...props }: FieldPrimitive.Root.Props) {
    return (
        <FieldPrimitive.Root
            data-slot={"field"}
            className={cn("flex flex-col items-start gap-2", className)}
            {...props}
        />
    );
}

function FieldLabel({ className, ...props }: FieldPrimitive.Label.Props) {
    return (
        <FieldPrimitive.Label
            data-slot={"field-label"}
            className={cn("inline-flex items-center gap-2 text-sm/4", className)}
            {...props}
        />
    );
}

function FieldDescription({ className, ...props }: FieldPrimitive.Description.Props) {
    return (
        <FieldPrimitive.Description
            data-slot={"field-description"}
            className={cn("text-xs text-muted-foreground", className)}
            {...props}
        />
    );
}

function FieldError({ className, ...props }: FieldPrimitive.Error.Props) {
    return (
        <FieldPrimitive.Error
            data-slot={"field-error"}
            className={cn("text-xs text-destructive", className)}
            {...props}
        />
    );
}

const FieldControl = FieldPrimitive.Control;
const FieldValidity = FieldPrimitive.Validity;

export { Field, FieldLabel, FieldDescription, FieldError, FieldControl, FieldValidity };
